// extracted by mini-css-extract-plugin
export var container = "_gt-1";
export var editor = "_gt-2";
export var resizable = "_gt-3";
export var wrapper = "_gt-0";